import I18n from 'i18n-js';
import React from 'react';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding-table.module.scss';
import { PendingRequestTableRow } from '../comunities-solicitudes-pendiente-list-page-new-onboarding-row/comunities-solicitudes-pendiente-list-page-new-onboarding-row';

interface PendingRequestsTableProps {
  data: SolicitudPendiente[];
  communityID: string;
}

export const PendingRequestsTable = (props: PendingRequestsTableProps): JSX.Element => {
  const { data, communityID } = props;
  const { t } = I18n;
  return (
    <table className={styles.table_wrapper}>
      {data.length > 0 ? (
        <>
          <thead>
            <tr>
              <th>{t(`PendingRequestsTable.headers.fechaAlta`)}</th>
              <th>{t(`PendingRequestsTable.headers.name`)}</th>
              <th>Email</th>
              <th>{t(`PendingRequestsTable.headers.telefono`)}</th>

              <th>{t(`PendingRequestsTable.headers.CUPS`)}</th>
              <th>{t(`PendingRequestsTable.headers.paso`)}</th>
              <th aria-label="Detail" />
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <PendingRequestTableRow key={row.id} row={row} communityID={communityID} />
            ))}
          </tbody>
        </>
      ) : (
        <p>{t(`PendingRequestsTable.headers.notResult`)}</p>
      )}
    </table>
  );
};
